import React from "react";

export const joinPetNames = (names: string[]): string => {
  const capitalized = names.map(
    (n) => n.charAt(0).toUpperCase() + n.slice(1),
  );

  if (capitalized.length === 1) return capitalized[0];
  if (capitalized.length === 2) {
    return `${capitalized[0]} and ${capitalized[1]}`;
  }

  const last = capitalized[capitalized.length - 1];

  return `${capitalized.slice(0, -1).join(", ")} and ${last}`;
};

interface MultiPetBannerProps {
  petNames: string[];
  label?: string;
}

export const MultiPetBanner = ({
  petNames,
  label = "Booking for:",
}: MultiPetBannerProps) => {
  if (petNames.length <= 1) return null;

  return (
    <div className="w-full bg-taupe-15 rounded-lg px-4 py-2 text-sm text-light-black">
      {label} <span className="font-semibold">{joinPetNames(petNames)}</span>
    </div>
  );
};
